export default [
    {
        "name": "Amazon",
        "imageSource": "https://alphauniverse.media.zestyio.com/retailer-amazon.png",
        "externalLinkUrl": "https://www.amazon.com/s/ref=sr_in_s_p_89_1383?fst=as%3Aoff&rh=n%3A172282%2Cn%3A%21493964%2Cn%3A502394%2Cp_89%3ASony&bbn=502394&ie=UTF8&qid=1478119705&rnid=2528832011",
        "externalLinkText": "View Sony gear on Amazon"
    },
    {
        "name": "Best Buy",
        "imageSource": "https://alphauniverse.media.zestyio.com/retailer-best-buy.png",
        "externalLinkUrl": "http://www.bestbuy.com/site/sony-store/sony-cameras-and-camcorders/pcmcat748300653383.c?id=pcmcat748300653383",
        "externalLinkText": "View Sony gear on Best Buy"
    },
    {
        "name": "B&H",
        "imageSource": "https://alphauniverse.media.zestyio.com/retailer-bh.png",
        "externalLinkUrl": "https://www.bhphotovideo.com/c/buy/Digital-Cameras/ci/5860/N/4232860169",
        "externalLinkText": "View Sony gear at B&H"
    },
    {
        "name": "Local Retailers",
        "imageSource": "",
        "externalLinkUrl": "",
        "externalLinkText": ""
    }
];